import { Typography, TextField, Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import "./gridControls.scss";

const ContainedLabel = ({ tab, value, model, dd, onUpdate, width }) => {
  const [data, setData] = useState(value);

  const handleFieldChange = () => (event) => {
    if (tab === "DD-Desc") {
      setData(event.target.value.toLowerCase());
    } else {
      setData(event.target.value);
    }
  };

  const updateText = async (event) => {
    if (event.key === "Enter" && String(data).trim() !== "") {
      if (tab === "models") {
        onUpdate(data, model);
      } else if (tab === "DD-Desc") {
        onUpdate(model, dd, data);
      }
    }
  };
  const onBlur = async (event) => {
    if (data && String(data).trim() !== "") {
      if (tab === "models") {
        onUpdate(data, model);
      } else if (tab === "DD-Desc") {
        onUpdate(model, dd, data);
      }
    }
  };

  return (
    <div
      className="contained-grid-container contained-label"
      style={{ width: width }}
    >
      {tab !== undefined && (
        <Tooltip title={data} placement="right-start" arrow>
          <TextField
            size="small"
            className="contained-grid-label"
            id="outlined-basic"
            placeholder=""
            label=""
            value={data}
            onChange={handleFieldChange()}
            onKeyDown={updateText}
            onBlur={onBlur}
          />
        </Tooltip>
      )}
      {tab === undefined && (
        <Typography className="contained-grid-label">{data}</Typography>
      )}
    </div>
  );
};

export default ContainedLabel;
